<template>
  <!-- Completion message region -->
  <v-card
    role="region"
    aria-labelledby="checkout-complete-heading"
    class="pa-4"
  >
    <!-- Invisible heading for SR context -->
    <h2
      id="checkout-complete-heading"
      class="sr-only"
    >
      {{ $t('components.checkout.completedHeading') || 'Checkout completed' }}
    </h2>

    <!-- Success alert -->
    <v-alert
      v-if="hasOrder"
      type="success"
      color="success"
      icon="check_circle"
      aria-live="assertive"
      border="left"
      dense
    >
      {{
        $t('components.checkout.completed', {
          points
        })
      }}
    </v-alert>

    <!-- Info note -->
    <v-alert
      v-if="hasOrder"
      type="info"
      color="info"
      icon="info"
      aria-live="polite"
      border="left"
      dense
    >
      {{ $t('components.checkout.noteCompleted') }}
    </v-alert>
  </v-card>
</template>

<script>
import links from "@/constants/links";
import { app } from "@/app";

export default {
    name: "CheckoutCompleted",
    data() {
        return {
            order: {}
        }
    },
    computed: {
        hasOrder() {
            return Object.keys(this.order).length > 0;
        },
        points() {
            return this.$store.getters.paymentPrices[this.order.amount];
        }
    },
    beforeMount() {
        this.$api.makeCompletedCheckout(
            this.$route.params.provider,
            this.$route.params.id
        );

        this.$api
            .getOrder(this.$route.params.id)
            .then(order => {
                this.order = order;
            })
            .catch(() => {
                app.then(({ $router }) => {
                    $router.push({
                        path: links.routes.checkout.replace("/:id", "")
                    });
                });
            });
    },
    methods: {}
};
</script>


<style scoped>
.sr-only {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
</style>
